import type { FC } from "react";

import { ValidationTags } from "src/app/features/ApplicationConfigurations/components/validations/ValidationTags";
import type { AppConfigsValidation } from "src/app/features/ApplicationConfigurations/types/AppConfigsTypes";
import type { AntCustomFormField } from "../../../../../components/Form/types/types";

export interface ApplicationConfigurationsValidationsProps extends AntCustomFormField<AppConfigsValidation> {}

export const ApplicationConfigurationsValidationsView: FC<ApplicationConfigurationsValidationsProps> = ({ value }) => {
    return <ValidationTags tags={value?.validations || []} showClose={false} />;
};
